export type {
  DrawerBodyState as NavDrawerBodyState,
  DrawerBodyProps as NavDrawerBodyProps,
  DrawerBodySlots as NavDrawerBodySlots,
} from '../../Drawer/DrawerBody/DrawerBody.types';
